import { appBottomClearanceClass } from "@/components/common/appBottomClearance";
import { createFileRoute } from "@tanstack/react-router";
import { selectPublishedFormsQueryOptions } from "../../features/forms/api/selectForms";
import { FormsTable } from "@patient-watch/forms";

const websiteUrl = import.meta.env.VITE_WEBSITE_URL || "https://patient.watch";

export const Route = createFileRoute("/forms/")({
    component: () => {
        const { forms } = Route.useLoaderData();
        return (
            <section className={`px-2 pt-2 md:px-4 md:pt-4 ${appBottomClearanceClass}`}>
                {forms && <FormsTable forms={forms} websiteUrl={websiteUrl} />}
            </section>
        );
    },
    loader: async ({ context }) => {
        const forms = await context.queryClient.ensureQueryData(selectPublishedFormsQueryOptions());
        return { forms };
    },
});
